function initializeComparisonTableBlock(root) {
  if (!root || root.dataset.comparisonTableInitialized === 'true') {
    return;
  }

  const accordionHeaders = root.querySelectorAll('.comparison-table-block__accordion-header');

  if (!accordionHeaders.length) {
    return;
  }

  root.dataset.comparisonTableInitialized = 'true';

  // Delegated on root rather than a listener per header found at init time:
  // querySelectorAll returns a static snapshot, and the editor canvas can
  // re-render headers inside an already-initialized root.
  root.addEventListener('click', (event) => {
    const header = event.target.closest('.comparison-table-block__accordion-header');

    if (!header) {
      return;
    }

    const content = header.nextElementSibling;
    const isActive = header.classList.contains('active');

    // Toggle current accordion
    if (isActive) {
      header.classList.remove('active');
      content.classList.remove('active');
      header.setAttribute('aria-expanded', 'false');
    } else {
      header.classList.add('active');
      content.classList.add('active');
      header.setAttribute('aria-expanded', 'true');
    }
  });
}

function initializeFrontend() {
  document.querySelectorAll('.comparison-table-block').forEach(initializeComparisonTableBlock);
}

if (window.acf) {
  window.acf.addAction('render_block_preview/type=comparison-table', ($block) => {
    initializeComparisonTableBlock($block.get(0));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFrontend);
} else {
  initializeFrontend();
}
